import { CSSProperties } from 'react';
import { Color, Size } from '@vivli/shared/theme';
import { ButtonView } from '@vivli/shared/views';
import { SubHeaderComponent } from './sub-header.component';
import { DTIInternalLinkMenu } from '@vivli/shared/infrastructure/constants';
import { useAppConfigContext } from '@vivli/core/infrastructure/context';

const containerStyle: CSSProperties = {
    maxHeight: Size.HEADER_HEIGHT,
    minHeight: Size.HEADER_HEIGHT,
    backgroundColor: Color.VIVLI_DARK_BLUE,
    boxShadow: Size.MENU_BOX_SHADOW,
    zIndex: 3,
    display: 'grid',
    gridTemplateColumns: '1fr auto',
};

const betaButtonStyle: CSSProperties = {
    backgroundColor: '#005475',
    height: '31px',
    margin: '10px 14px 10px 10px',
    background: '#0097c6',
};

export const InternalLinkMenuComponent = () => {
    const { viewRequestResultsOnly, myDataRequestsEnabled } = useAppConfigContext();

    const handleBetaFeedbackClick = () => {
        const win = window.open('https://www.surveymonkey.com/r/6FCS2XK', '_blank');
        win.focus();
    };

    return (
        <div style={containerStyle}>
            <div>
                {!myDataRequestsEnabled && (
                    <ButtonView
                        onClick={handleBetaFeedbackClick}
                        style={betaButtonStyle}
                        className="header_feedbackLink"
                        data-test-id={DTIInternalLinkMenu.HeaderFeedbackLink}
                    >
                        Give Us Beta Feedback!
                    </ButtonView>
                )}
            </div>

            {!viewRequestResultsOnly && <SubHeaderComponent />}
        </div>
    );
};
